/*==================================================
    program name    : UI 初始化處理
    author          : Samma
    last update     : 2020-05-06
    use description : 
==================================================*/
import $ from 'jquery';

export default {
  //集中呼叫所有相關事件
  initUiEffect: function () {
    this.navEffectForScroll();
    this.generateScrollToTopBtn();
    this.scrollEffect();
  },
  //頁面滾動時，nav 效果
  navEffectForScroll: function () {
    $(window).scroll(function () {
      if ($(window).scrollTop() > 0) {
        $('.orangelinebg').removeClass('orangelinebg-top');
        $('.logo').addClass('logo2');
      } else {
        $('.orangelinebg').addClass('orangelinebg-top');
        $('.logo').removeClass('logo2');
      }
    });
  },
  //產生右下角 scroll to top UI button + 回到頂端
  generateScrollToTopBtn: function () {
    require('@/assets/framework/jquery.easing.min');
    require('@/assets/framework/move-top');
    $().UItoTop({ easingType: 'easeOutQuart' });
  },
  //卷軸滾動效果 (滑到指定的位置)
  scrollEffect: function () {
    $(document).on('click', 'a.page-scroll', function (event) {
      event.preventDefault();
      var target = $(this).attr('href');
      $('html,body').animate(
        {
          scrollTop: $(target).offset().top - 100,
        },
        1250,
        'easeOutExpo'
      );
    });
  },
};
